import axios from 'axios';
import { baseURL } from '../Constants';

interface Get5Team {
  id: number;
  name: string;
  tag?: string;
  flag?: string;
  logo?: string;
}

class TeamService {
  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  async getTeams(): Promise<any[]> {
    try {
      const response = await axios.get(
        `${baseURL}/Team`,
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching teams:', error);
      throw error;
    }
  }

  async getGet5Teams(): Promise<Get5Team[]> {
    try {
      // Fetch teams from the backend Get5 endpoint
      const response = await axios.get(
        `${baseURL}/Get5/teams`,
        { headers: this.getAuthHeaders() }
      );
      
      // The response should already be in Get5 format
      return response.data;
    } catch (error) {
      console.error('Error fetching Get5 teams:', error);
      return [];
    }
  }

  async syncTeamsToGet5(): Promise<{ success: boolean; message: string }> {
    try {
      const response = await axios.post(
        `${baseURL}/Get5/sync/teams`,
        {},
        { headers: this.getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error syncing teams to Get5:', error);
      throw error;
    }
  }
}

export const teamService = new TeamService();